var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdPlanPerkHighlightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#01c0fa",
    opacity: 1,
    "data-original": "#a9fffd",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26a6fe",
    d: "M512 256c0-41.475-9.874-80.64-27.383-115.29l-49.55-49.55L78.695 351.734l73.582 73.602-19.948 30.529 43.222 43.222C200.852 507.456 227.894 512 256 512c141.385 0 256-114.615 256-256z",
    opacity: 1,
    "data-original": "#6cd5ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "m194.808 356.948-16.094 64.377H256l62.16-30.212L256 351.019z",
    opacity: 1,
    "data-original": "#898989",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "m317.192 356.948 16.094 64.377H256v-70.306z",
    opacity: 1,
    "data-original": "#686868",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M86.165 95.605v249.882H256l107.336-104.585L256 95.605z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M256 95.605h169.835v249.882H256z",
    opacity: 1,
    "data-original": "#e5e5e5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f4f4f",
    d: "M103.665 331.745a6.216 6.216 0 0 1-6.209-6.21V115.557a6.216 6.216 0 0 1 6.209-6.209H256l35.242-10.751L256 79.348H103.665c-19.966 0-36.209 16.244-36.209 36.209v209.978c0 19.966 16.244 36.21 36.209 36.21H256l38.643-14.679L256 331.745z",
    opacity: 1,
    "data-original": "#4f4f4f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    d: "M408.335 79.348H256v30h152.335a6.216 6.216 0 0 1 6.209 6.209v209.978a6.216 6.216 0 0 1-6.209 6.21H256v30h152.335c19.966 0 36.209-16.244 36.209-36.21V115.557c0-19.966-16.243-36.209-36.209-36.209z",
    opacity: 1,
    "data-original": "#303030",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f4f4f",
    d: "M132.33 446.445v9.42H256l57.077-20.235L256 415.395h-92.62c-17.149 0-31.05 13.902-31.05 31.05z",
    opacity: 1,
    "data-original": "#4f4f4f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    d: "M379.67 455.866v-9.42c0-17.148-13.902-31.05-31.05-31.05H256v40.47z",
    opacity: 1,
    "data-original": "#303030",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f4f4f",
    d: "m226.28 199.667 20.672 29.583-92.272 64.478-20.672-29.583z",
    opacity: 1,
    "data-original": "#4f4f4f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe70d",
    d: "m254.522 166.002-30.145-13.523 2.336 32.956-26.783 19.345 29.707 14.451L233 252.102l23-15.546 30.585-38.234L256 165.003z",
    opacity: 1,
    "data-original": "#ffe445",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed402",
    d: "m290.517 247.124-2.336-32.957 26.783-19.344-29.707-14.452-3.363-32.87L256 165.003v71.553l4.373-2.955z",
    opacity: 1,
    "data-original": "#ffbb12",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffbb12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m361.39 222.795 4.309 20.888 19.84 7.827-15.935 14.176 3.142 21.095-20.244-6.712-16.699 13.269-4.309-20.889-19.84-7.826 15.935-14.176-3.142-21.096 20.244 6.712zM352.829 142.087l2.044 12.67 11.722 5.225-9.95 8.105 1.336 12.765-11.995-4.565-10.386 7.539-2.044-12.67-11.722-5.225 9.951-8.105-1.337-12.765 11.995 4.566z",
    fill: "#fed402",
    opacity: 1,
    "data-original": "#ffbb12",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdPlanPerkHighlightIcon);
export default __webpack_public_path__ + "static/media/ad-plan-perk-highlight-icon.089997a5a7995e8258696566816f94df.svg";
export { ForwardRef as ReactComponent };